import React from 'react';
import { MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import { Tooltip, Popconfirm, Skeleton } from "antd";
import Pagination from '@material-ui/lab/Pagination';
import moment from 'moment';
import { Info, Edit } from '@material-ui/icons';
import './insideTable.css';

const InsideTable = ({ isRTL, allStrings, data = [], columns = [], removeAction, viewAction, editAction, toggleMedia, loading = false, title, addBtnTitle, subtitle, page = 1, pages = 1, onPageChange }) => {

    const pageNum = Number(page) || 1;
    const pagesNum = Number(pages) || 1;

    // Construct columns with "Actions" appended if removeAction, viewAction, or editAction exists
    let tableCols = [...columns];
    if (removeAction || viewAction || editAction) {
        tableCols.push({
            title: allStrings.more,
            key: 'actions',
            render: (val) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                    {viewAction && (
                        <span onClick={() => viewAction(val)} style={{ margin: "4px", cursor: 'pointer' }}>
                            <Tooltip title={allStrings.info} placement="top">
                                <Info style={{ color: '#33d633' }} />
                            </Tooltip>
                        </span>
                    )}
                    {editAction && (
                        <span onClick={() => editAction(val)} style={{ margin: "4px", cursor: 'pointer' }}>
                            <Tooltip title={allStrings.edit} placement="top" arrow>
                                <Edit style={{ color: 'cornflowerblue', fontSize: '20px' }} />
                            </Tooltip>
                        </span>
                    )}
                    {removeAction && (
                        <span style={{ margin: "4px", cursor: 'pointer' }} >
                            <Tooltip title={allStrings.delete} placement="top">
                                <Popconfirm
                                    title={allStrings.areYouSureDelete}
                                    okText={allStrings.yes}
                                    cancelText={allStrings.no}
                                    onConfirm={() => removeAction(val.id)}
                                >
                                    <MDBIcon far icon="trash-alt" style={{ color: '#FF3547', fontSize: '18px' }} />
                                </Popconfirm>
                            </Tooltip>
                        </span>
                    )}
                </div>
            )
        });
    }

    if (isRTL) {
        tableCols = [...tableCols].reverse();
    }

    return (
        <MDBRow>
            <MDBCol md="12">
                <div className="media-table-container">
                    {/* Header Section */}
                    <div className="media-table-header" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                        <div className="media-table-header-info" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                            <div className="media-table-icon-wrapper" style={{ marginLeft: isRTL ? '15px' : '0', marginRight: isRTL ? '0' : '15px' }}>
                                <MDBIcon far icon="file-alt" className="media-table-icon" />
                            </div>
                            <div style={{ textAlign: isRTL ? 'right' : 'left' }}>
                                <h4 className="media-table-title">{title}</h4>
                                <p className="media-table-subtitle">{subtitle}</p>
                            </div>
                        </div>
                        {toggleMedia && (
                            <button onClick={toggleMedia} className="media-table-add-btn">
                                <span>{addBtnTitle}</span>
                                <MDBIcon icon="plus" />
                            </button>
                        )}
                    </div>

                    {/* Table Section */}
                    <div className="table-responsive">
                        <table className="table media-table-wrapper">
                            <thead className="media-table-head">
                                <tr style={{ textAlign: 'center', color: '#112A3F' }}>
                                    {tableCols.map((col, idx) => (
                                        <th key={col.key || idx} className="media-table-th">
                                            {col.title}
                                            {col.key !== 'actions' && <MDBIcon icon="sort" className={isRTL ? "ml-1" : "mr-1"} style={{ color: '#A0AAB5' }} />}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ?
                                    <tr>
                                        <th colSpan={tableCols.length || 1} className="noData">
                                            <Skeleton height={40} />
                                        </th>
                                    </tr>
                                    :
                                    data && data.length > 0 ?
                                        data.map((val, index) => (
                                            <tr key={val.id || index} style={{ textAlign: 'center' }}>
                                                {tableCols.map((col, idx) => {
                                                    let cellValue = val[col.dataIndex];
                                                    if (cellValue && (col.type === 'date' || col.dataIndex?.toLowerCase().includes('date'))) {
                                                        const mDate = moment(cellValue);
                                                        if (mDate.isValid()) {
                                                            cellValue = isRTL
                                                                ? mDate.locale('ar').format('ll')
                                                                : mDate.locale('en').format('ll');
                                                        }
                                                    }
                                                    return (
                                                        <td key={col.key || idx} className="media-table-td" style={col.dataIndex === 'id' ? { color: '#112A3F' } : col.dataIndex === 'mediaType' ? { color: '#6F7884', fontWeight: '500' } : {}}>
                                                            {col.render ? col.render(val, index) : cellValue}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))
                                        :
                                        <tr>
                                            <td colSpan={tableCols.length || 1} className="media-table-empty">
                                                <div style={{ position: 'relative', width: '145px', height: '145px', margin: '25px auto 20px' }}>
                                                    <div style={{ width: '100%', height: '100%', backgroundColor: '#F4F9F9', borderRadius: '50%', position: 'absolute', bottom: 0, zIndex: 1 }}></div>
                                                    <div style={{ position: 'relative', zIndex: 2, top: '40px' }}>
                                                        <MDBIcon icon="box-open" className="media-table-empty-icon" />
                                                        <MDBIcon icon="file-alt" style={{ fontSize: '40px', color: '#fff', position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', textShadow: '0 2px 4px rgba(0,0,0,0.1)' }} />
                                                    </div>
                                                </div>
                                                <h5 style={{ fontWeight: 'bold', color: '#112A3F', margin: '10px 0' }}>لا يوجد بيانات</h5>
                                                <p style={{ color: '#6F7884', marginBottom: '0px', fontSize: '15px', pointerEvents: 'none' }}>لم يتم إضافة أي بيانات بعد</p>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* Footer Section (Pagination) */}
                    {onPageChange && (
                        <div className="media-table-pagination" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                            <div className="media-table-rows-info">
                                {allStrings?.rowsPerPage || '10 صفوف لكل صفحة'}
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <button className="media-table-page-btn" onClick={() => pageNum !== 1 && onPageChange(1)} disabled={pageNum === 1} style={{ opacity: pageNum === 1 ? 0.5 : 1 }}>
                                    {allStrings?.first || 'الأول'}
                                </button>
                                <button className="media-table-page-btn" onClick={() => pageNum > 1 && onPageChange(pageNum - 1)} disabled={pageNum === 1} style={{ opacity: pageNum === 1 ? 0.5 : 1 }}>
                                    {allStrings?.previous || 'السابق'}
                                </button>

                                <Pagination
                                    page={pageNum}
                                    count={pagesNum}
                                    onChange={(event, p) => p !== pageNum && onPageChange(p)}
                                    hidePrevButton
                                    hideNextButton
                                    renderItem={(item) => {
                                        if (item.type === 'page') {
                                            return (
                                                <button
                                                    key={item.page}
                                                    className={`media-table-page-btn ${item.selected ? 'active' : ''}`}
                                                    onClick={item.onClick}
                                                    disabled={item.disabled}
                                                >
                                                    {item.page}
                                                </button>
                                            )
                                        }
                                        if (item.type === 'start-ellipsis' || item.type === 'end-ellipsis') {
                                            return <span key={item.type} style={{ padding: '6px 5px', color: '#A0AAB5' }}>...</span>
                                        }
                                        return null;
                                    }}
                                />

                                <button className="media-table-page-btn" onClick={() => pageNum < pagesNum && onPageChange(pageNum + 1)} disabled={pageNum === pagesNum} style={{ opacity: pageNum === pagesNum ? 0.5 : 1 }}>
                                    {allStrings?.next || 'التالي'}
                                </button>
                                <button className="media-table-page-btn" onClick={() => pageNum !== pagesNum && onPageChange(pagesNum)} disabled={pageNum === pagesNum} style={{ opacity: pageNum === pagesNum ? 0.5 : 1 }}>
                                    {allStrings?.last || 'الأخير'}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                <br></br>
            </MDBCol>
        </MDBRow>
    );
};

export default InsideTable;
